import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';
import { getCookie } from '../@core/utils/get-cookie.utils';
import { ContractsService } from '../services/contracts.service';
import { UsersService } from '../services/users.service';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(
    private usersService: UsersService,
    private router: Router,
    private oidcSecurityService: OidcSecurityService,
    private contractsService: ContractsService,
    private envService: EnvironmentService
  ) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {

    if (state.url.endsWith('/my-documents')) {
      const token = getCookie('myesse_access_token');
      if (token) {
        this.router.navigate(['/my-documents-mobile']);
        return true;
      }
    } else if (state.url.endsWith('/hr-documentation')) {
      const token = getCookie('myesse_access_token');
      if (token) {
        this.router.navigate(['/hr-documentation-mobile']);
        return true;
      }
    }

    const loginOidc = localStorage.getItem('oidc-login') ?? undefined;
    const isProduction = this.envService.production;

    if (!loginOidc) {
      if (isProduction) {
        this.router.navigate(['/auth/login']);
        return false;
      } else {
        this.router.navigate(['/open-mobile-app-or-prod']);
        return false;
      }
    }
    const isAuthenticated = await firstValueFrom(this.oidcSecurityService.isAuthenticated(loginOidc));

    if (!isAuthenticated) {
      if (isProduction) {
        this.router.navigate(['/auth/login']);
      } else {
        this.router.navigate(['/open-mobile-app-or-prod']);
      }
    }

    const contractsToAccept = await firstValueFrom(this.contractsService.getToAccept());

    if (contractsToAccept && contractsToAccept.length > 0) {
      this.router.navigate(['/acceptance']);
    }

    const userIsHired = await this.usersService.getUserIsHired();
    if (!userIsHired) {
      this.router.navigate(['/hiring']);
    }
    return isAuthenticated;
  }

  async canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    return this.canActivate(next, state);
  }
}
